import { useState } from 'react';
import { PersonListItemType } from '@api';
import { TouringDataTable, useManageTableContext } from '@common*';
import { DataTable } from 'mantine-datatable';
import {
  usePersonsOverviewSubtableColumns,
  usePersonsOverviewTableColumns,
  usePersonsTableActions,
} from './hooks';

const BORDER_COLOR = 'var(--mantine-color-gray-2)';

type PersonsOverviewTablePropsType = {
  persons: PersonListItemType[];
  isPending: boolean;
};

export const PersonsOverviewTable: React.FC<PersonsOverviewTablePropsType> = ({
  persons,
  isPending,
}) => {
  const [expandedPersonIds, setExpandedPersonIds] = useState<string[]>([]);

  const { handleEditPerson, handleDeletePerson } = usePersonsTableActions();

  const handleToggleExpand = (record: PersonListItemType) => {
    setExpandedPersonIds(
      expandedPersonIds.includes(record.id)
        ? expandedPersonIds.filter((id) => id !== record.id)
        : [...expandedPersonIds, record.id]
    );
  };

  const { columns } = usePersonsOverviewTableColumns({
    handleDeletePerson,
    handleToggleExpand,
    expandedPersonIds,
  });

  const { columns: subTableColumns } = usePersonsOverviewSubtableColumns();

  const { tableArguments: table } = useManageTableContext();

  return (
    <TouringDataTable<PersonListItemType>
      columns={columns}
      records={persons}
      onRowClick={(row) => handleEditPerson(row.record)}
      {...table.pagination}
      {...table.sorting}
      rowExpansion={{
        trigger: 'never',
        allowMultiple: true,
        expanded: {
          recordIds: expandedPersonIds,
          onRecordIdsChange: setExpandedPersonIds,
        },
        content: ({ record }) => (
          <DataTable
            columns={subTableColumns}
            records={record.companies}
            withRowBorders
            noHeader
            striped="even"
            borderColor={BORDER_COLOR}
            withColumnBorders={true}
          />
        ),
      }}
      fetching={isPending}
    />
  );
};
